import React from 'react';

interface CircleLoaderProps {
  color?: string;
  backgroundColor?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
  duration?: number;
  label?: string;
  className?: string;
  ariaLabel?: string;
}

const CircleLoader: React.FC<CircleLoaderProps> = ({
  color = '#4285f4',
  backgroundColor = '#f0f0f0',
  width = 80,
  height = 80,
  strokeWidth = 6,
  duration = 1.5,
  label = '',
  className = '',
  ariaLabel = 'Loading...'
}) => {
  const radius = 35;
  const dashArray = '80 220';
  const viewBoxSize = 80;
  
  // Calculate label position based on SVG dimensions
  const labelYPosition = viewBoxSize + 15;

  return (
    <div 
      className={`circle-loader ${className}`}
      style={{ width: `${width}px`, height: `${height}px` }}
      aria-label={ariaLabel}
      role="status"
    >
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Background circle */}
        <circle
          cx={viewBoxSize/2}
          cy={viewBoxSize/2}
          r={radius}
          stroke={backgroundColor}
          strokeWidth={strokeWidth}
          fill="none"
        />
        
        {/* Animated circle */}
        <circle
          cx={viewBoxSize/2}
          cy={viewBoxSize/2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={dashArray}
          strokeDashoffset="0"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from={`0 ${viewBoxSize/2} ${viewBoxSize/2}`}
            to={`360 ${viewBoxSize/2} ${viewBoxSize/2}`}
            dur={`${duration}s`}
            repeatCount="indefinite"
          />
          <animate
            attributeName="strokeDashoffset"
            values="0; -300"
            dur={`${duration}s`}
            repeatCount="indefinite"
          />
        </circle>
        
        {label && (
          <text
            x={viewBoxSize/2}
            y={labelYPosition}
            textAnchor="middle"
            fill={color}
            fontSize="12"
            className="loader-label"
          >
            {label}
          </text>
        )}
      </svg>
    </div>
  );
};

export default CircleLoader;